import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "salesOn",
  "use": "salesOn-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 40 40\" id=\"salesOn\">\n\t<g fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\"2\">\n\t\t<rect width=\"11.109\" height=\"11.758\" x=\"5\" y=\"24.242\" rx=\"2\" />\n\t\t<rect width=\"11.109\" height=\"16.089\" x=\"5\" y=\"2.469\" rx=\"2\" />\n\t\t<rect width=\"13.886\" height=\"25.27\" x=\"21.102\" y=\"6.923\" rx=\"2\" />\n\t</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol